module.exports = __webpack_public_path__ + "img/zhihuigushi-1@3x.ddd93c4a.png";